// extracted by mini-css-extract-plugin
export default {"title":"pba-z","warning":"qba-z","sizeOptionsLegendText":"rba-z"};